/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExternalAcademicUserLoginResponseDTO
 */
export interface ExternalAcademicUserLoginResponseDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserLoginResponseDTO
	 */
	token: string;
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserLoginResponseDTO
	 */
	refreshToken: string;
}

export function ExternalAcademicUserLoginResponseDTOFromJSON(
	json: any
): ExternalAcademicUserLoginResponseDTO {
	return ExternalAcademicUserLoginResponseDTOFromJSONTyped(json, false);
}

export function ExternalAcademicUserLoginResponseDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ExternalAcademicUserLoginResponseDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		token: json["token"],
		refreshToken: json["refreshToken"],
	};
}

export function ExternalAcademicUserLoginResponseDTOToJSON(
	value?: ExternalAcademicUserLoginResponseDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		token: value.token,
		refreshToken: value.refreshToken,
	};
}
